/*
 * Copyright (c) Logan Group Services - Gaston Longhitano <gaston.longhitano@logangroupservices.com>
 * All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

export const BITRATE_AUTO  = 'Auto';
export const BITRATE_2160p = '2160p';
export const BITRATE_1080p = '1080p';
export const BITRATE_720p  = '720p';
export const BITRATE_480p  = '480p';
export const BITRATE_360p  = '360p';

export const getImagePath = (url, site, shootId, fragmentId = null) => {
  if (!url)
    return;

  const replacementVars = {
    image_server: settings.image_server + '/shoots/' + site,
    site: site,
    ShootID: shootId,
    fragmentId: fragmentId,
  };

  Object.keys(replacementVars).forEach(key => {
    url = url.replace(RegExp('\\[' + key + '\\]', 'gm'), replacementVars[key]);
  });

  return 'https:' + url;
};

export const getVideoPath = (url, site, shootId, resolution, fragmentId = null) => {
  const replacementVars = {
    video_server: settings.video_server + '/shoots/' + site,
    ShootID: shootId,
    fragmentId: fragmentId,
    resolution: getVideoBitrate(resolution),
    site: site,
  };

  Object.keys(replacementVars).forEach(key => {
    url = url.replace(RegExp('\\[' + key + '\\]', 'gm'), replacementVars[key]);
  });

  return 'https:' + url;
};


export const getVideoBitrate = (resolution) => {
  return resolution === BITRATE_AUTO ? calculateBitrateBandwidth() : resolution;
};

export const calculateBitrateBandwidth = () => {
  const downlink = navigator?.connection?.downlink ?? 0;
  if (downlink > 5) return  BITRATE_1080p;
  if (downlink > 1.5) return BITRATE_720p;
  if (downlink > 0.5) return BITRATE_480p;

  return BITRATE_360p;
};


const settings = {
  site: "sexadventure",
  image_server: "sm-members.bangbros.com",
  video_server: "cdn77-lg-members.bangbros.com",
  poster: "//[image_server]/shoots/[site]/[ShootID]/poster/[ShootID]_[fragmentId]_2160.jpg",
  thumbnail: "//[image_server]/shoots/[site]/[ShootID]/square/[ShootID]_[fragmentId]_400.jpg",
  resource: "//[video_server]/shoots/[site]/[ShootID]/[resolution]/[ShootID]_[fragmentId]_[resolution].mp4",
  video: "//[video_server]/shoots/[site]/[ShootID]/streaming/[ShootID]-[resolution].mp4"
};
